import Vue from 'vue';
import { setupOpenApiFixupInterceptor } from '@gslc/models';
import vuetify from './plugins/vuetify';
import router from './plugins/vue-router';
import segment from './plugins/segment';
// import store from './store/index';
import App from './App.vue';
import { Auth0Plugin } from './auth';
import { globalStore } from './stores/globalStore';
import 'plyr/dist/plyr.css';
import './scss/main.scss';

Vue.use(Auth0Plugin, {
  onRedirectCallback: (appState: any) => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  },
});

Vue.use(segment);

Vue.config.productionTip = false;

async function bootstrapApp() {
  if (process.env.VUE_APP_IS_PRODUCTION !== 'true') {
    if (localStorage?.getItem('api-mock-enabled') === 'true') {
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      const { worker } = require('./mocks/browser');
      await worker.start();
    }
  }
  // this is a workaround related to an issue in openapi-generator for openapi-client-axios https://github.com/OpenAPITools/openapi-generator/issues/5717
  // basically it is serializing json body unnecessarily
  setupOpenApiFixupInterceptor();
  new Vue({
    data: { pageLoading: true },
    vuetify,
    store: globalStore,
    router,
    render: h => h(App),
  }).$mount('#app');
}

bootstrapApp();
